import Vue from 'vue'
import axios from 'axios'
import storage from './config/auth'
import conf from './config/config'
import * as filters from './config/index.js'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import md5 from 'js-md5';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
let Base64 = require('js-base64').Base64;
if (process.env.NODE_ENV !== 'development') {
  axios.defaults.baseURL = process.env.VUE_APP_API;
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.http = Vue.prototype.$http = axios
Vue.storage = Vue.prototype.$storage = storage
Vue.conf = Vue.prototype.$conf = conf
Vue.md5 = Vue.prototype.$md5 = md5
Vue.Base64 = Vue.prototype.$Base64 = Base64
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
